
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.56 0c-.833 0-1.5.702-1.5 1.558v6.806c0 .5.164.893.44 1.16.275.266.651.398 1.06.398h4.666c.832 0 1.5-.701 1.5-1.558V1.558C9.726.702 9.058 0 8.226 0H3.56zm-.367 1.558c0-.217.168-.386.367-.386h4.666c.199 0 .367.17.367.386v6.806a.377.377 0 01-.367.386H3.56a.377.377 0 01-.367-.386V1.558z","fill":"#58697D"}}),_c('path',{attrs:{"d":"M1.134 2.48a.289.289 0 00-.13-.243.256.256 0 00-.28-.001A1.57 1.57 0 000 3.569v5.348c0 1.662 1.295 3.016 2.9 3.016h3.267a1.49 1.49 0 001.293-.768.26.26 0 00-.01-.276.29.29 0 00-.242-.127h-3.84l-.153-.006h-.002c-.701.002-1.225-.26-1.57-.675-.349-.418-.524-1-.51-1.648V2.48z","fill":"#58697D"}})])
          )
        }
      }
    